import { ISuggestion } from '../../../types/fio';

export function getNewGender(value: string, suggestFiltered: ISuggestion[]) {
  const val = suggestFiltered.find(item => item.value.toLowerCase() === value.toLowerCase());

  return val ? val.data.gender : null;
}
